import { render, staticRenderFns } from "./author-view.vue?vue&type=template&id=52a385d2&"
import script from "./author-view.vue?vue&type=script&lang=js&"
export * from "./author-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports